import React, { useEffect, useRef, useState } from 'react'
import { fetchStatus } from '../../services/managerApi/statusApi'
import SelectInput from '../../blocks/ui/SelectInput'
import InputRegister from '../../blocks/ui/InputRegister'
import { formatNames } from '../../../utils/formatNames'
import { createProfileAction } from '../../services/profileAction'
// import Loading from '../Loading'
// import { label } from 'framer-motion/client'

export default function ProfileSubmission({ candidateId, jobId, BeURL, showAlert, processType, setShow, refreshProfiles }) {
    const [allStatus, setAllStatus] = useState([])
    const [selectedStatus, setSelectedStatus] = useState('')
    const [subcategory, setsubcategory] = useState('')

    const [note, setNote] = useState('')
    const [scheduledDate, setScheduledDate] = useState('')
    const [doj, setDoj] = useState('')
    const [ctc, setCTC] = useState('')
    const [empId, setEmpId] = useState('')

    // UpdateStatus Duplicate prevent code :
    const lastClickState = useRef(false)
    const [delayLoading, setDelayLoading] = useState(false)



    useEffect(() => {
        const fetchStatuses = async () => {
            await fetchStatus(BeURL, showAlert, setAllStatus)
        }
        fetchStatuses()
    }, [BeURL, showAlert])

    // Get the selected status object for label check
    const selectedStatusObj = allStatus.find(s => s._id === selectedStatus)
    const selectedLabel = selectedStatusObj ? formatNames(selectedStatusObj.status) : ''

    const handleSubmit = async () => {
        // Double click prevent

        if (lastClickState.current) return

        const validations = [
            {
                condition: !selectedStatus,
                message: "Status is required"
            },
            {
                condition:
                    [
                        'L1 Scheduled',
                        "Customer Hold",
                        "L1 Reject",
                        "L1 Select",
                        "L2 Reject",
                        'L2 Scheduled',
                        "L2 Select",
                        "L3 Reject",
                        'L3 Scheduled',
                        "L3 Select",
                        "Screen Reject",
                        "Screen Select",
                        "Postion Hold",
                        "Final Select",
                        "Interview Scheduled",
                        "Rejected By Buyer",
                        "Waiting For Evaluation Open Demand",
                        "Yet To Share",
                        "Candidate Hold",
                        "Waiting For Client Round Feedback",
                        "Client Round Scheduled",
                        "Recruiter Rejected"
                    ].includes(selectedLabel) && !scheduledDate,
                message: "Date is required"
            },
            {
                condition: ['Offer Yet To Release (oyr)'].includes(selectedLabel) && !doj,
                message: "Expect Date of Join is required"
            },
            {
                condition:
                    (selectedLabel === 'Offer Yet To Join (oyj)' || subcategory === 'Offer Yet to Join(OYJ)')
                    && (!doj || !ctc),
                message: "Date of Join or Offered CTC is required"
            },
            {
                condition: selectedLabel === 'Joined' && !empId,
                message: "Employment ID is required"
            },
            {
                condition: selectedLabel === 'Joined' && !doj,
                message: "Date of joining is required"
            },
            {
                condition: selectedLabel === 'Joined' && !ctc,
                message: "Ctc is Required"
            },
            {
                condition: ['Offer Yet To Join (OYJ)'].includes(selectedLabel) && !ctc,
                message: "Offered Ctc is required"
            },
            {
                condition: ['Offer Yet To Join (OYJ)'].includes(selectedLabel) && !doj,
                message: "Date id required"
            }
        ];

        // Run validations
        for (let v of validations) {
            if (v.condition) {
                // console.log("ghghg")
                showAlert(v.message);
                return;
            }
        }
        lastClickState.current = true
        setDelayLoading(true)
        try {
            const payload = {
                "jobId": jobId,
                "candidateId": candidateId,
                "type": processType,
                "status": selectedStatus,
            }
            if (note)
                payload.note = note
            if (scheduledDate)
                payload.scheduledDate = scheduledDate
            if (doj)
                payload.doj = doj
            if (ctc)
                payload.offeredCtc = ctc
            if (empId)
                payload.empId = empId
            if (subcategory)
                payload.subcategory = subcategory

            const success = await createProfileAction(BeURL, showAlert, payload, setShow)

            if (success) {
                setShow(false)
                if (refreshProfiles)
                    refreshProfiles()
            }
        }
        catch (err) {
            console.log("Error in Update Status Submit inDouble Click", err)
        }
        finally {
            lastClickState.current = false
            setDelayLoading(false)
        }

    }

    return (
        <div className="space-y-4">

            {/* Status Dropdown */}
            <SelectInput
                label="Status"
                mandatory
                value={selectedStatus}
                onChange={e => setSelectedStatus(e.target.value)}
                options={allStatus
                    .filter(s => s.isActive)
                    .map(s => ({ label: formatNames(s.status), value: s._id }))
                }
                placeholder="Select Status"
            />

            {/* Note */}
            <InputRegister
                label="Note"
                value={note}
                name="note"
                // mandatory
                // required
                placeholder="Note"
                type="text"
                className="w-full"
                onChange={e => setNote(e.target.value)}
            />

            {!["Offer Yet To Join (OYJ)", "Joined", "Bgv Green", "Waiting For L1 Panel"].includes(selectedLabel) && (
                <InputRegister
                    label={`${selectedLabel} Date`}
                    value={scheduledDate}
                    name="scheduledDate"
                    mandatory
                    required
                    placeholder="Scheduled Date"
                    type="date"
                    className="w-full"
                    onChange={e => setScheduledDate(e.target.value)}
                />
            )}

            {(selectedLabel === "Offer Yet To Join (OYJ)" && (
                <div>
                    <InputRegister
                        label="Offered CTC : (in LPA)"
                        value={ctc}
                        name="ctc"
                        mandatory
                        required
                        placeholder="Ex:4.5"
                        type="text"
                        className="w-full"
                        onChange={e => {
                            if (/^[0-9.]*$/.test(e.target.value)) {
                                setCTC(e.target.value);
                            }
                        }}

                    />
                    <InputRegister
                        label="Expect Date of joining"
                        value={doj}
                        name="doj"
                        mandatory
                        required
                        placeholder="Date of Join"
                        type="date"
                        className="w-full"
                        onChange={e => setDoj(e.target.value)}
                    />
                </div>
            ))}

            {selectedLabel === 'Bgv Green' && (
                <SelectInput
                    label="Sub Category"
                    mandatory
                    value={subcategory}
                    onChange={e => setsubcategory(e.target.value)}
                    options={[
                        { label: 'Offer Yet to Join (OYJ)', value: 'Offer Yet to Join(OYJ)' },
                        { label: 'Offer Yet to Release(OYR)', value: 'Offer Yet to Release(OYR)' },
                        { label: 'Final Select', value: 'Final Select' },
                    ]}
                    placeholder="Select Status"
                />
            )}

            {/* Offered Yet to Join (OYJ) */}
            {(selectedLabel === 'Offer Yet To Join (oyj)' || subcategory === 'Offer Yet to Join(OYJ)') && (
                <>
                    <InputRegister
                        label="Date of Join"
                        value={doj}
                        name="doj"
                        mandatory
                        required
                        placeholder="Date of Join"
                        type="date"
                        className="w-full"
                        onChange={e => setDoj(e.target.value)}
                    />

                    <InputRegister
                        label="Offered CTC : (in LPA)"
                        value={ctc}
                        name="ctc"
                        mandatory
                        required
                        placeholder="Ex:4.5"
                        type="text"
                        className="w-full"
                        onChange={e => {
                            if (/^[0-9.]*$/.test(e.target.value)) {
                                setCTC(e.target.value);
                            }
                        }}

                    />
                </>
            )}

            {/* Joined */}
            {selectedLabel === 'Joined' && (
                <div>
                    <InputRegister
                        label="Employment ID"
                        value={empId}
                        name="empId"
                        mandatory
                        required
                        placeholder="Employment ID"
                        type="text"
                        className="w-full"
                        onChange={e => setEmpId(e.target.value)}
                    />
                    <InputRegister
                        label="Date of Join"
                        value={doj}
                        name="doj"
                        mandatory
                        required
                        placeholder="Date of Join"
                        type="date"
                        className="w-full"
                        onChange={e => setDoj(e.target.value)}
                    />
                    <InputRegister
                        label="Offered CTC : (in LPA)"
                        value={ctc}
                        name="ctc"
                        mandatory
                        required
                        placeholder="Ex:4.5"
                        type="text"
                        className="w-full"
                        onChange={e => {
                            if (/^[0-9.]*$/.test(e.target.value)) {
                                setCTC(e.target.value);
                            }
                        }}
                    />
                </div>
            )}

            <div className='flex justify-end gap-6'>
                <button
                    onClick={() => handleSubmit()}
                    disabled={delayLoading}
                    className={`mt-4 px-4 py-2 font-semibold rounded ${delayLoading ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-primary-400 text-white cursor-pointer'}`}
                >
                    Submit
                </button>
                <button
                    onClick={() => setShow(false)}

                    className="mt-4 px-4 py-2 border-primary-400 border-2 text-primary-400 font-semibold rounded "
                >
                    Close
                </button>
            </div>
        </div>
    )
}
